import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Users, Timer } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";

const fade = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.45 },
};

export const EarlyBirdCountdown = ({ until }) => {
  const { t } = useLang();
  const days = Math.ceil((new Date(until) - new Date()) / 86400000);
  if (days <= 0) return null;
  return (
    <div
      className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-[#0B1B3A] text-white text-xs font-bold"
      data-testid="earlybird-countdown"
    >
      <Timer className="w-3.5 h-3.5" />
      {days === 1 ? t("live.ebOneDayLeft") : `${days} ${t("live.ebDaysLeft")}`}
    </div>
  );
};

export const InstructorsSection = ({ courseId }) => {
  const { t } = useLang();
  const [people, setPeople] = useState([]);

  useEffect(() => {
    api.get("/instructors")
      .then((r) => setPeople(r.data.filter((p) => (p.course_ids || []).includes(courseId))))
      .catch(() => {});
  }, [courseId]);

  if (people.length === 0) {
    return (
      <motion.div {...fade} className="card-cream p-8" data-testid="program-instructors-box">
        <Users className="w-6 h-6 text-[#1D4ED8]" />
        <h3 className="font-heading font-black text-2xl mt-4">{t("live.instructorsTitle")}</h3>
        <p className="text-[#475569] mt-3">{t("live.instructorsTba")}</p>
      </motion.div>
    );
  }

  return (
    <motion.div {...fade} className="card-cream p-8" data-testid="program-instructors-list">
      <Users className="w-6 h-6 text-[#1D4ED8]" />
      <h3 className="font-heading font-black text-2xl mt-4">{t("live.instructorsTitle")}</h3>
      <div className="mt-6 space-y-5">
        {people.map((p) => (
          <div key={p.id} className="flex items-start gap-4" data-testid={`program-instructor-${p.id}`}>
            {p.photo ? (
              <img src={p.photo} alt={p.name} className="w-16 h-16 rounded-2xl object-cover shrink-0" loading="lazy" />
            ) : (
              <span className="w-16 h-16 rounded-2xl bg-[#1D4ED8] text-white font-heading font-black text-xl grid place-items-center shrink-0">
                {p.name.slice(0, 1)}
              </span>
            )}
            <div>
              <p className="font-heading font-black text-base text-[#0B1B3A]">{p.name}</p>
              {p.title && <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#1D4ED8] mt-1">{p.title}</p>}
              {p.bio && <p className="text-sm text-[#475569] mt-2">{p.bio}</p>}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};
